module.exports = __webpack_public_path__ + "img/temp-home-03.55b7b987.jpg";